import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import _ from "@lodash";
import TextField from "@mui/material/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Card, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useParams } from "react-router-dom";
import YouthImportantDaysTable from "./components/youthImportantDaysTable";
import { AutoAwesome } from "@mui/icons-material";

const defaultValues = {
  programStartDate: "",
  programEndDate: "",
  registrationStartDate: "",
  registrationEndDate: "",
  eligibilityStartDate: "",
  eligibilityEndDate: "",
  certificationStartDate: "",
  certificationEndDate: "",
  orientationStartDate: "",
  orientationEndDate: "",
  bankingStartDate: "",
  bankingEndDate: "",
  jobApplicationStartDate: "",
  jobApplicationEndDate: "",
  resumeUploadStartDate: "",
  resumeUploadEndDate: "",
  description: "",
  date: "",
};

const schema = yup.object().shape({});

export default function YouthImportantDays() {
  const routeParams = useParams();
  const [isAiLoading, setIsAiLoading] = useState(false);

  const { id } = routeParams;

  const { control, handleSubmit, watch, formState, setValue } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;
  const form = watch();

  const [formValues, setFromValue] = useState({
    employeeType: "",
  });

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFromValue({
      ...formValues,
      [name]: value,
    });
  };

  const generateDates = async () => {
    setIsAiLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));

    setValue("programStartDate", "2025-06-01");
    setValue("programEndDate", "2025-07-15");

    setValue("registrationStartDate", "2025-04-01");
    setValue("registrationEndDate", "2025-04-15");

    setValue("eligibilityStartDate", "2025-04-16");
    setValue("eligibilityEndDate", "2025-04-30");

    setValue("certificationStartDate", "2025-05-01");
    setValue("certificationEndDate", "2025-05-08");

    setValue("orientationStartDate", "2025-05-01");
    setValue("orientationEndDate", "2025-05-08");

    setValue("bankingStartDate", "2025-05-01");
    setValue("bankingEndDate", "2025-05-08");

    setValue("resumeUploadStartDate", "2025-04-16");
    setValue("resumeUploadEndDate", "2025-04-30");

    setValue("jobApplicationStartDate", "2025-05-09");
    setValue("jobApplicationEndDate", "2025-05-31");
    setIsAiLoading(false);
  };

  return (
    <>
      <Button
        className="mt-2 ml-24 bg-gradient-to-r from-green-400 to-blue-500"
        variant="contained"
        disabled={isAiLoading}
        startIcon={<AutoAwesome />}
        onClick={() => generateDates()}
      >
        {isAiLoading ? "Generating..." : "Generate with AI"}
      </Button>
      <Card variant="outlined" className="m-24 mb-0">
        <div className="m-24 mt-8">
          <div className="flex grid lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-2 gap-16 content-start">
            <div className="flex">
              <Controller
                control={control}
                name="programStartDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Program Start Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="programEndDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Program End Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <div className="flex">
              <Controller
                control={control}
                name="registrationStartDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Registration Start Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="registrationEndDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Registration End Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <div className="flex">
              <Controller
                control={control}
                name="jobApplicationStartDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Job Application Start Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>
            <div className="flex">
              <Controller
                control={control}
                name="jobApplicationEndDate"
                render={({ field }) => (
                  <DatePicker
                    className="mt-16 w-full"
                    label="Job Application End Date"
                    value={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date?.toISOString())}
                    slotProps={{ textField: { size: "small" } }}
                  />
                )}
              />
            </div>

            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-16 w-full"
                  label="Description"
                  placeholder="Description"
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={!!errors.description}
                  helperText={errors?.description?.message}
                />
              )}
            />
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <DatePicker
                  className="mt-16 w-full"
                  label="Date"
                  value={field.value ? new Date(field.value) : null}
                  onChange={(date) => field.onChange(date?.toISOString())}
                  slotProps={{ textField: { size: "small" } }}
                />
              )}
            />
          </div>
          <div className="flex mt-24">
            <Button
              className="mx-8"
              variant="contained"
              color="secondary"
              disabled={false}
            >
              Add
            </Button>
          </div>
          <YouthImportantDaysTable />
          <div className="flex items-center justify-end mt-32">
            <Button
              className="mx-8"
              variant="contained"
              color="secondary"
              disabled={false}
            >
              Save
            </Button>
          </div>
        </div>
      </Card>
    </>
  );
}
